import { useCallback, useMemo } from 'react';
import { Control, useWatch } from 'react-hook-form';
import { EventVenueMap } from 'src/components/Events/VenueMap/EventVenueMap';
import { GetColorCallback } from 'src/components/Events/VenueMap/VenueMapProps';
import { useEventMapContext } from 'src/contexts/EventMapContext';
import { vars } from 'src/core/themes';
import { PurchaseTicketsInput } from 'src/utils/purchaseUtils';
import { SectionInfo } from 'src/WebApiController';

export const PurchaseTicketGroupVenueMap = ({
  control,
  onSectionClicked,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<PurchaseTicketsInput, any>;
  onSectionClicked: (e: MouseEvent, sectionInfo: SectionInfo) => void;
}) => {
  const { venueMapInfo } = useEventMapContext();

  const ticketGroups = useWatch({
    control: control,
    name: 'ticketGroups',
  });

  const sectionIds = useMemo(() => {
    if (!ticketGroups) return [];
    return ticketGroups.reduce((acc, data) => {
      // If sectionId is not provided, try to derive it from venueMapInfo.
      if (!data.sectionId?.value) {
        if (!venueMapInfo) return acc;
        const sectionId = venueMapInfo.sections.find(
          (section) => section.name === data.section?.value
        )?.id;
        if (sectionId) {
          acc.push(sectionId);
        }
        return acc;
      }
      if (data.sectionId.value) {
        acc.push(data.sectionId.value);
      }
      return acc;
    }, [] as number[]);
  }, [ticketGroups, venueMapInfo]);

  const getColor: GetColorCallback = useCallback(({ isSelected }) => {
    if (isSelected) {
      return {
        fill: vars.color.backgroundHighlight,
        stroke: vars.color.textBrandV2,
      };
    }
    return {
      fill: vars.color.surfacePrimary,
      stroke: vars.color.textSecondaryV2,
      textColor: vars.color.textSecondaryV2,
    };
  }, []);

  return (
    <EventVenueMap
      onSectionClicked={onSectionClicked}
      selectedSectionIds={sectionIds}
      allowDrawLine={false}
      getColor={getColor}
    />
  );
};
